module.exports = __webpack_public_path__ + "static/media/engine-fan_green.3086d53f.png";